import { render, staticRenderFns } from "./Pt_Detail.vue?vue&type=template&id=c9cccd4e&scoped=true&"
import script from "./Pt_Detail.vue?vue&type=script&lang=js&"
export * from "./Pt_Detail.vue?vue&type=script&lang=js&"
import style0 from "./Pt_Detail.vue?vue&type=style&index=0&id=c9cccd4e&lang=scss&scoped=true&"
import style1 from "./Pt_Detail.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9cccd4e",
  null
  
)

export default component.exports